import { render, staticRenderFns } from "./Login_Alternate.vue?vue&type=template&id=7d1b70a4&scoped=true&"
import script from "./Login_Alternate.vue?vue&type=script&lang=js&"
export * from "./Login_Alternate.vue?vue&type=script&lang=js&"
import style0 from "./Login_Alternate.vue?vue&type=style&index=0&id=7d1b70a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1b70a4",
  null
  
)

export default component.exports